import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../LanguageContext';
import { useTheme } from '../ThemeContext';

const Footer = () => {
  const { t, lang } = useLang();
  const theme = useTheme();

  const legalLinks = lang === 'fr'
    ? [
        { to: '/mentions-legales', label: 'Mentions légales' },
        { to: '/confidentialite', label: 'Confidentialité' },
        { to: '/cgv', label: 'CGV' }
      ]
    : [
        { to: '/mentions-legales', label: 'Legal notice' },
        { to: '/confidentialite', label: 'Privacy' },
        { to: '/cgv', label: 'Terms of sale' }
      ];

  return (
    <footer className="border-t border-[#d4a94c]/15 py-10" style={{ background: theme.primary }}>
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img
            src="https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/c7p1pt64_LOGO%20MURAT.jpg"
            alt="Murat"
            className="h-10 w-auto object-contain"
            style={{ filter: 'invert(1) hue-rotate(180deg)', mixBlendMode: 'lighten' }}
          />
          <div className="flex flex-col">
            <span className="text-[9px] tracking-[0.3em] text-[#d4a94c] uppercase leading-none">
              {t.nav.since}
            </span>
            <span className="text-[8px] tracking-[0.3em] text-[#f6ecd9]/60 uppercase mt-1 leading-none">
              Feuilletées & Pâtisseries
            </span>
          </div>
        </div>

        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          {legalLinks.map((link, i) => (
            <Link
              key={i}
              to={link.to}
              className="text-[10px] tracking-[0.25em] uppercase text-[#f6ecd9]/70 hover:text-[#d4a94c] transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <p className="text-[10px] tracking-[0.3em] uppercase text-[#f6ecd9]/50 text-center md:text-right">
          © {new Date().getFullYear()} — {t.contact.footer}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
